import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions/business.actions';
import { BusinessModel } from '@boxx/onboarding-core';
export const featureKey = 'business_dash';

export interface BusinessState {
  data: BusinessModel | any;
  eventTypes: any;
  loaded: {
    success: boolean | any,
    after: string | any,
    data?: any
  }
  hasError: boolean;
  loading: boolean;
  error: any;
  success: any;
  successTypes: any;
};

export const initialState: BusinessState = {
  data: null,
  eventTypes: null,
  loaded: {
    success: false,
    after: '',
    data: ''
  },
  hasError: false,
  loading: false,
  error: null,
  success: false,
  successTypes: false
};

const businessReducer = createReducer(initialState,

  on(fromActions.loadBusinessBegin, state => ({ ...state, loading: true })),

  on(fromActions.loadBusinessSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: true,
      after: 'BUSINESS_LOADED'
    },
    hasError: false,
    data: payload,
    success: true
  })),

  on(fromActions.loadBusinessError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: false,
      after: 'BUSINESS_LOADED'
    },
    hasError: true,
    error: payload,
    success: false
  })),

  on(fromActions.loadEventHistoryTypesBegin, state => ({ ...state, loading: false })),

  on(fromActions.loadEventHistoryTypesSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: true,
      after: 'EVETS_HISTORY_TYPES'
    },
    hasError: false,
    eventTypes: payload,
    success: true
  })),

  on(fromActions.loadEventHistoryTypesError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: false,
      after: 'EVETS_HISTORY_TYPES'
    },
    hasError: true,
    eventTypes: payload,
    success: false
  })),

  on(
    fromActions.updateBusinessNFCAction,
    (state) => ({
      ...state,
      businessState: {
        ...state.data,
        isLoading: false,
        success: null,
        error: null,
        data: {
          ...state.data,
          nfc_sync: true,
        },
      },
    })
  ),

  on(
    fromActions.updateImagesSite,
    (state, { payload }): any => ({
      ...state.data,
      data: {
        ...state.data,
        images: payload,
      },
      loading: false,
      loaded: {
        success: true,
        after: 'BUSINESS_IMAGES_UPDATED'
      },
      hasError: false,
      success: true

    })
  ),

  on(fromActions.updateThemeSuccess, (state, { payload }) => {
    return {
      ...state,
      data: {
        ...state.data,
        color_theme_id: payload
      },
      loading: false,
      success: {
        after: 'THEME_UPDATED',
        message: ''
      }
    };
  }),

);

export const BusinessReducer = (state: BusinessState | undefined, action: Action) =>
  businessReducer(state, action);

export const isLoading = (state: BusinessState) => state.loading;
export const succeeded = (state: BusinessState) => state.success;
export const hasError = (state: BusinessState) => state.hasError;
export const errorMessage = (state: BusinessState) => state.error;
export const businessData = (state: BusinessState) => state.data;

export const succeededTypes = (state: BusinessState) => state.successTypes;
export const eventTypesData = (state: BusinessState) => state.eventTypes;

